import React, { useContext, useEffect, useState } from 'react';
import { FilterContext } from 'components/FilterBar/FilterProvider';
import KpiDefinitionData from '../../../../service/KpiDefinitionData';
import { useDynamicGraphQLQuery } from '../../../../hooks/useDynamicGraphQLQuery';
import CardContainer from 'components/redesign/CardContainer';
import { KpiData } from 'components/redesign/KpiTile/types';
import KpiGrid from 'components/redesign/KpiGrid';
import KpiTile from 'components/redesign/KpiTile';
import totalAlerts from 'v2/kpis/mct/mctScorecard/totalAlerts';
import assignedAlerts from 'v2/kpis/mct/mctScorecard/assignedAlerts';
import criticalAlerts from 'v2/kpis/mct/mctScorecard/criticalAlerts';
import openAlerts from 'v2/kpis/mct/mctScorecard/openAlerts';

interface MCTScorecardProps {
  title?: string;
  setOverviewConfig?: (config: string[]) => void;
}

const MCTScorecard: React.FC<MCTScorecardProps> = ({ title = '' }) => {
  const { selectedProduct, selectedPlant } = useContext(FilterContext);
  const [overViewConfig, setOverviewConfig] = useState<KpiData[]>([]);
  // Using the dynamic GraphQL query instead of the useOperationalMetrics hook
  const { data: mctScorecardData, isLoading: scorecardLoading } =
    useDynamicGraphQLQuery(
      'getMCTVCScorecard',
      {
        siteId: selectedPlant?.id ? selectedPlant?.id : null,
      },
      true
    );

  useEffect(() => {
    if (mctScorecardData?.getMCTVCScoreCard?.data) {
      // Set the overview configuration with the handlers
      const updatedOverviewConfig = [
        totalAlerts.handler(mctScorecardData?.getMCTVCScoreCard?.data),
        assignedAlerts.handler(mctScorecardData?.getMCTVCScoreCard?.data),
        criticalAlerts.handler(mctScorecardData?.getMCTVCScoreCard?.data),
        openAlerts.handler(mctScorecardData?.getMCTVCScoreCard?.data),
      ];

      // Set the updated overview config
      setOverviewConfig(updatedOverviewConfig);
    }
  }, [mctScorecardData]);

  return (
    <CardContainer
      isLoading={scorecardLoading}
      title={title}
      showInfoIcon={true}
      dataDefinitions={{
        sections:
          KpiDefinitionData[selectedProduct?.productId]?.operationalMetrics
            ?.scoreCard ?? [],
      }}
      isAccordion={false}
    >
      <KpiGrid
        columnsDesktop={overViewConfig?.length ? overViewConfig?.length : 4}
        columnsTablet={overViewConfig?.length ? overViewConfig?.length : 4}
        columnsMobile={1}
      >
        {overViewConfig.map((item, index) => (
          <KpiTile key={index} data={item} />
        ))}
      </KpiGrid>
    </CardContainer>
  );
};

export default MCTScorecard;
